import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TelegramIcon from "@mui/icons-material/Telegram";
import WebIcon from "@mui/icons-material/Web";
import { Link, Paper, Stack, Typography } from "@mui/material";

const list = [
  {
    name: "Github",
    icon: <GitHubIcon sx={{ mb: "-7px" }} />,
    url: "https://github.com/rileymtt",
  },
  {
    name: "Website",
    icon: <WebIcon sx={{ mb: "-7px" }} />,
    url: "https://withriley.club/",
  },
  {
    name: "LinkedIn",
    icon: <LinkedInIcon sx={{ mb: "-7px" }} />,
    url: "https://www.linkedin.com/in/rileymtt/",
  },
  {
    name: "Telegram",
    icon: <TelegramIcon sx={{ mb: "-7px" }} />,
    url: "https://t.me/rileymtt",
  },
];

export default function Socials() {
  return (
    <Stack direction={"row"} spacing={1} alignItems={"center"}>
      {list.map((item) => (
        <Link
          key={item.name}
          href={item.url}
          target="_blank"
          underline="none"
          color="inherit"
        >
          <Paper
            sx={{
              p: 2,
              mb: 1,
              "&:hover": { backgroundColor: "rgba(255,193,7,1)" },
            }}
          >
            {item.icon}
          </Paper>
          <Typography
            fontWeight={"bold"}
            fontSize={10}
            align="center"
            color="textSecondary"
          >
            {item.name}
          </Typography>
        </Link>
      ))}
    </Stack>
  );
}
